// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"820":"4e88cdcd","4411":"4e88cdcd","5440":"4e88cdcd","6711":"1fa45812"}[chunkId] + ".chunk.css";
};